<template>
  <div class="success-info">
    <asset-v3
      class="prclx-logo"
      dir="logos"
      name="logo.svg"
    />

    <div class="title">
      <span name="check" class="success-icon">
        <CheckIcon size="12" color="var(--white)" />
      </span>
      <h3>Parabéns, <span v-if="name" class="primary">
        {{ name | capitalize({ first: true }) }}
        </span>
      </h3>
    </div>

    <h2 class="gray-700">
      Você está pré-aprovado* para comprar com o Parcelex
    </h2>

    <p class="options-text">
      Isso quer dizer que você tem um <span class="body-bold primary">limite de crédito
      pré-aprovado de até {{ maxCreditValue | moneyFilter }}</span> para
      compras parceladas no boleto em até {{ bestPricing.installments }} vezes,
      <span v-if="bestPricing.downPayment">
        com entrada mínima de {{ bestPricing.downPaymentPercentage }}% e
        juros a partir de {{ bestPricing.interest * 100 | floatFilter }}% a.m.
      </span>
      <span v-else>
        com juros a partir de {{ bestPricing.interest * 100 | floatFilter }}% a.m.
      </span>
    </p>

    <p class="extra-info">
      *O limite de crédito informado ainda está sujeito a alteração ou
      reprovação no momento da compra.
    </p>

    <h4 class="gray-700">
      Comece a comprar agora mesmo em uma de nossas lojas parceiras
    </h4>

    <PartnersSlider
      class="partner-slider"
      :partners="partners"
      :gap="8"
      :borderRadius="8"
    />
  </div>
</template>

<script>
import { CheckIcon } from '@vue-hero-icons/outline';

import { mapState, mapActions } from 'vuex';
import AssetV3 from '@/components/common/AssetV3.vue';
import PartnersSlider from './PartnersSlider.vue';
import { colors } from '../utils/colors';
import { partners } from '../../../utils/partners';
import stringMixin from '../../../mixins/string';

export default ({
  name: 'AccessSucceedCard',
  data: () => ({
    partners,
  }),
  mixins: [stringMixin],
  components: {
    PartnersSlider,
    AssetV3,
    CheckIcon,
  },
  computed: {
    ...mapState('login', ['maxCreditValue', 'bestPricing', 'name']),
    gradientColors() {
      return colors.BLUE;
    },
  },
  methods: {
    ...mapActions('login', ['sendEvent']),
  },
  mounted() {
    this.sendEvent({ type: 'approved' });
  },
});

</script>

<style lang="scss" scoped>

.success-info {
    background-color: var(--white);
    padding: 36px;
    border-radius: 16px;
    box-shadow:
      0px 100px 80px rgba(0, 0, 0, 0.07),
      0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
      0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),
      0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
      0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),
      0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
    max-width: 492px;
    max-height: 600px;
    margin-top: 1.5rem;

    .title {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;

      span {
        width: 20px;
      }
    }
  }

  .success-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: var(--success);
    display: flex;
    justify-content: center;
    align-items: center;

    &__icon {
      width: 12.5px;
      filter: brightness(0) invert(1);
    }
  }

  .options-text {
    @extend .body-regular;
    margin: 16px 0;
  }

  .extra-info {
    @extend .small-regular;
    margin-bottom: 24px;
    color: var(--gray-500)
  }

  .partner-slider {
    margin-top: 20px;
    width: calc(96px * 1 + 8px * 1);

    @media (min-width: 300px){
      width: calc(96px * 2 + 8px * 2);
    }

    @media (min-width: 400px){
      width: calc(96px * 3 + 8px * 3);
    }
    @media (min-width: 500px){
      width: calc(96px * 4 + 8px * 4);
    }
  }

  .prclx-logo {
    margin-bottom: 24px;
  }

@media (max-width: $breakpoint-large) {
  .success-info {
    padding: 24px;
    height: 100vh;
    box-sizing: border-box;

    .title {
      margin-bottom: 12px;
    }
  }
}

</style>
